import React, { createContext, useContext, ReactNode } from 'react';
import { useSwornBuilder } from '../hooks/useSwornBuilder';

// Define the type of the context value based on the return type of the hook
type SwornBuilderContextType = ReturnType<typeof useSwornBuilder>;

const SwornBuilderContext = createContext<SwornBuilderContextType | null>(null);

export const SwornBuilderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const swornBuilderState = useSwornBuilder();

    return (
        <SwornBuilderContext.Provider value={swornBuilderState}>
            {children}
        </SwornBuilderContext.Provider>
    );
};

export const useSwornBuilderContext = () => {
    const context = useContext(SwornBuilderContext);
    if (!context) {
        throw new Error('useSwornBuilderContext must be used within a SwornBuilderProvider');
    }
    return context;
};
